import {clearString, FullAlphabet} from "../helpers/stringHelpers";

const cachedNumeric = {};
const Numeric = {
    mineaplhabet: function (missing) {
        let mergedMissing = missing.join('');
        if (cachedNumeric[mergedMissing]) {
            return cachedNumeric[mergedMissing]
        }
        let myAlphabet = FullAlphabet.filter((str) => {
            return missing.every((a)=>{
                return str !== a.toLowerCase().replace('ch', '*')
            })
            // return str !== missing[0].toLowerCase().replace('ch', '*') &&
            //     str !== missing[1].toLowerCase().replace('ch', '*') &&
            //     str !== missing[2].toLowerCase().replace('ch', '*')
        })
        cachedNumeric[mergedMissing] = myAlphabet;
        return cachedNumeric[mergedMissing];
        // return myAlphabet;
    }


}
const SEPARATOR = ' '
export const methods = {
    cypher: function (input, hasCh=false, missing = [], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input,hasCh)//.replaceAll(/[ ]/g,'')
        missing.forEach((char)=>{
            cleared = cleared.replaceAll(char,'')
        })
        let characters = cleared.split('');//.forEach((char)=>{ });
        for (let i = 0; i < characters.length; i++){
            let char = characters[i];
            if(char.match(/[.,?! ]/)){
                cyphered.push(char);
            }else{
                cyphered.push(Numeric.mineaplhabet(missing).indexOf(characters[i])+1);
            }

        }

        return cyphered.join(sep)
            .replaceAll('*','ch')
    },
    decypher: function (input, hasCh=false, missing = [], params, sep = SEPARATOR) {
        let deciphered = []
        // let text = input.replace('ch','*')
        let cleared = clearString(input, hasCh);
        let characters = cleared.split(sep).map((c)=>c.trim());
        characters.forEach((char)=>{
            if(char.match(/[.,?! ]/)){
                deciphered.push(char);
            }else{
                let charNum = parseInt(char);
                deciphered.push(Numeric.mineaplhabet(missing)[charNum-1]);
            }
        });
        // text.split('').forEach((char) => {//.replace(' ','') bd;chi;jk;rs;kt mo;kt;bd;tv;is
        //
        // });
        return deciphered.join('')
            .replaceAll('*','ch')
    },
};

export default {...methods,SEPARATOR}